exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-bbaf6682]{width:100%;height:100%}body[data-v-bbaf6682]{overflow-y:hidden}.home[data-v-bbaf6682]{margin-top:-80px}.home .content[data-v-bbaf6682]{width:100%;display:flex;justify-content:center;margin-top:-177px}.home .content div[data-v-bbaf6682]{height:306px;width:370px}.icp[data-v-bbaf6682]{margin-bottom:5px;text-align:center;width:100%;color:#777;text-decoration:underline;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bbaf6682","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pcHome.vue
// module id = 128
// module chunks = 0